import { createFileRoute } from "@tanstack/react-router";
import { AdminShell } from "@/components/admin/AdminShell";
import { AmlPage } from "@/components/admin/aml/AmlPage";
import { requireAdmin } from "@/lib/require-admin";

export const Route = createFileRoute("/admin_/aml")({
  beforeLoad: () => {
    requireAdmin();
  },
  component: () => (
    <AdminShell page="aml">
      <AmlPage />
    </AdminShell>
  ),
});
